(() => {
  const sourceKey = 'cuf-enquiry-source-v2';
  const pendingKey = 'cuf-enquiry-pending-v1';
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'gbraid', 'wbraid', 'srsltid'];
  const forms = [...document.querySelectorAll('form[data-cuf-enquiry]')];
  const privacyReady = () => typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function' && typeof window.Shopify?.customerPrivacy?.marketingAllowed === 'function';
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return privacy?.analyticsProcessingAllowed?.() === true && privacy?.marketingAllowed?.() === true;
  };
  let memory = null;
  let initialised = false;
  let storageAvailable = true;
  const clean = (value, limit = 512) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').slice(0, limit);
  const read = (key) => {
    try { return JSON.parse(window.sessionStorage.getItem(key) || 'null'); }
    catch { storageAvailable = false; return null; }
  };
  const write = (key, value) => {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); }
    catch { storageAvailable = false; }
  };
  const remove = (key) => {
    try { window.sessionStorage.removeItem(key); } catch { storageAvailable = false; }
  };
  const safeUrl = (value, includeParameters) => {
    try {
      const url = new URL(value);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      const safe = new URL(url.origin + url.pathname);
      if (includeParameters) keys.forEach((key) => {
        if (url.searchParams.has(key)) safe.searchParams.set(key, clean(url.searchParams.get(key)));
      });
      return clean(safe.href, 4096);
    } catch { return ''; }
  };
  const snapshot = () => {
    const params = new URLSearchParams(window.location.search);
    let referrer = '';
    try {
      const url = new URL(document.referrer);
      if (url.origin !== window.location.origin) referrer = safeUrl(url.href, false);
    } catch {}
    const source = { captured_at_utc: new Date().toISOString(), landing_page: safeUrl(window.location.href, true), referrer };
    keys.forEach((key) => { source[key] = clean(params.get(key)); });
    return source;
  };
  const validTouch = (touch) => touch && typeof touch.landing_page === 'string' && typeof touch.captured_at_utc === 'string';
  const label = (touch) => {
    if (touch.gclid || touch.gbraid || touch.wbraid) return 'Google advertising (click identifier observed)';
    if (touch.utm_source || touch.utm_medium) return [touch.utm_source || 'unspecified source', touch.utm_medium || 'unspecified medium'].join(' / ');
    if (touch.srsltid) return 'Google product listing (paid status unconfirmed)';
    try { if (touch.referrer) return 'Referral: ' + new URL(touch.referrer).hostname; } catch {}
    return 'Unknown: no source signal';
  };
  const fill = (values) => forms.forEach((form) => {
    form.querySelectorAll('[data-cuf-source]').forEach((input) => {
      input.value = values[input.dataset.cufSource] || '';
      if (input.dataset.cufSource === 'source_details') input.disabled = !input.value;
    });
  });
  const update = () => {
    if (!allowed()) {
      memory = null;
      initialised = false;
      remove(sourceKey);
      remove('cuf-enquiry-source-v1');
      remove(pendingKey);
      fill({ source_summary: privacyReady() ? 'Not captured: tracking consent not granted.' : 'Not captured: privacy API unavailable or not ready.' });
      return;
    }
    if (!initialised) {
      const stored = read(sourceKey);
      memory = validTouch(stored?.first) && validTouch(stored?.last) ? stored : null;
      const current = snapshot();
      if (!memory) memory = { first: current, last: current };
      else if (keys.some((key) => current[key]) || current.referrer) memory.last = current;
      write(sourceKey, memory);
      remove('cuf-enquiry-source-v1');
      initialised = true;
    }
    const signature = (touch) => JSON.stringify(['landing_page', 'referrer', ...keys].map((key) => touch[key] || ''));
    const different = signature(memory.first) !== signature(memory.last);
    const summary = (touch) => label(touch) + (touch.utm_campaign ? '; campaign: ' + touch.utm_campaign : '');
    const details = ['Page: ' + safeUrl(window.location.href, true)];
    const touches = different ? [['First', memory.first], ['Last', memory.last]] : [['First/last', memory.first]];
    for (const [name, touch] of touches) {
      details.push(name + ' observed UTC: ' + touch.captured_at_utc, name + ' landing: ' + touch.landing_page);
      if (touch.referrer) details.push(name + ' referrer: ' + touch.referrer);
      let landingParams;
      try { landingParams = new URL(touch.landing_page).searchParams; } catch {}
      const params = keys.filter((key) => touch[key] && landingParams?.get(key) !== touch[key]);
      if (params.length) details.push(name + ' parameters: ' + params.map((key) => key + '=' + encodeURIComponent(touch[key])).join('&'));
    }
    if (!different && memory.last.captured_at_utc !== memory.first.captured_at_utc) details.push('Last observed UTC: ' + memory.last.captured_at_utc);
    details.push('Scope: first observed after consent in this tab; latest tagged/external entry; attribution parameters only.');
    const values = {
      source_summary: (different ? 'First: ' + summary(memory.first) + ' | Last: ' + summary(memory.last) : summary(memory.first)) + (storageAvailable ? '' : ' (current page only: browser storage unavailable)'),
      source_details: details.join('\n'),
    };
    fill(values);
  };
  forms.forEach((form) => {
    const reference = form.querySelector('[data-cuf-reference]');
    if (reference) reference.value = window.crypto?.randomUUID?.() || 'CUF-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
    form.addEventListener('submit', () => {
      update();
      if (allowed() && reference?.value) write(pendingKey, { id: reference.value, path: window.location.pathname, form: form.id, at: Date.now() });
    });
  });
  const conversion = () => {
    if (!allowed()) return;
    const pending = read(pendingKey);
    const form = forms.find((candidate) => candidate.id === pending?.form);
    if (!form?.querySelector('[data-cuf-enquiry-success]') || !pending?.id || !Number.isFinite(pending.at) || Date.now() - pending.at < 0 || Date.now() - pending.at >= 600000 || pending.path !== window.location.pathname || typeof window.gtag !== 'function') return;
    remove(pendingKey);
    window.gtag('event', 'conversion', { send_to: 'AW-18250937827/VHqTCLuXzt4cEOPr3P5D', transaction_id: pending.id, value: 0, currency: 'GBP' });
  };
  const refresh = () => { update(); conversion(); };
  document.addEventListener('visitorConsentCollected', refresh);
  refresh();
  if (!privacyReady() && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => { if (!error) refresh(); });
  }
})();
